import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import * as serviceWorker from './lib/serviceWorker';

// Debug: Log API URL being used
console.log('API URL:', import.meta.env.VITE_API_URL);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Register service worker for PWA support
serviceWorker.register({
  onSuccess: (registration) => {
    console.log('Service Worker registered successfully:', registration);
  },
  onUpdate: (registration) => {
    console.log('New content available; please refresh.');
    // Optionally show a toast notification
    if (window.confirm('New version available! Reload to update?')) {
      window.location.reload();
    }
  },
});

// Build: 2026-03-21
